import {createSlice} from '@reduxjs/toolkit' 
import {
    setServerRequestStatus,
    setLicenceApplicationPaymentStatus,
    IsInternalId,
    savePaymentRequestDetails
} from './primaryAgencyApplicationSlice'

import {
    LICENCE_STATUS_NEW,
    APPLICATION_MODE_RENEW,
    SURETYBOND_STATUS_NONE,
    PAYMENT_STATUS_NONE,
    PAYMENT_STATUS_INPROGRESS,
    PAYMENT_STATUS_FAILURE,
    FETCH_APPLICATIONS_URL,
    PAYMENT_URL,
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    APPLICATION_STATUS_PENDING_PAYMENT,
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION,
    ERROR_CODE,
    REQUEST_STATUS,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
    LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
    LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
    APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL,
    FETCH_ARCHIVE_APPLICATIONS_URL,
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION,
    APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE,
    APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE,
    APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE,
    APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE,
    // DOCUMENT_TYPE_SURETY_BONDS
}  from "../../app/constants"
import { fullName, validateAgentData, validateBranchData } from '../../app/utils'
import { setAgencyApplication } from './primaryAgencyApplicationSlice'
import { 
    setAdditionalApplications,
    resetAdditionalApplications, 
} from './additionalApplicationsSlice'
import { isAgencyTypeApplication, isIndividualTypeApplication, isReadyForPayment } from './applicationsUtils'
import { bltCollectionAgencyReviewData } from '../selector/BLTReviewData/collectionsReviewData'

const initialApplicationState = () => ({
        additionalBranches: [],
        applicationStatus : APPLICATION_STATUS_PENDING_PAYMENT,
        businessLicenceElsewhere : false,
        businessName : "",
        changeType : "SAVE",
        complianceOfficer: {
            emailAddress : "",
            firstName : "",
            lastName : "",
            phoneNumber : ""
        },
        confirmSuretyBond : 0,
        criminalHistoryData : [],
        endDate : "",
        errorCode : "",
        errorMessage : "",
        financialRecordsLocation : {
            city: "",
            country : "",
            number : 0,
            province : "",
            singleLineAddress : "",
            street : ""
        },
        internalNotes : "",
        licenceHistoryList : [],
        licenceStatus : LICENCE_STATUS_NEW,
        licenceSuspendedData : [],
        mainBusinessContact : {
            emailAddress : "",
            firstName : "",
            lastName : "",
            phoneNumber : ""
        },
        registryNumber : "",
        reviewDataCollectionDebt : null,
        serviceCivicAddress : {
            city: "",
            country : "",
            number : 0,
            province : "",
            singleLineAddress : "",
            street : ""
        },
        serviceBusinessAddress : {
            city: "",
            country : "",
            number : 0,
            province : "",
            singleLineAddress : "",
            street : ""
        },
        startDate : "",
        trustAccountInstitution : {
            address : {
                city: "",
                country : "",
                number : 0,
                province : "",
                singleLineAddress : "",
                street : ""
            },
            branchName : "",
            name : ""
        },
        updatedInRjsc : 0,
        workHistoryData : [],
        suretyBondStatus : SURETYBOND_STATUS_NONE,
        paymentStatus : PAYMENT_STATUS_NONE,
        licenceNumber : ""
    })

const collectionApplicationSlice = createSlice({
    name : "collectionServiceApplication",
    initialState : initialApplicationState(),
    reducers : {
        resetApplicationDataDeprecated(state, action) {
            state = initialApplicationState()
        },
        setApplicationDataDeprecated (state, action) {
            Object.assign(state,action.payload)
        },
        setSaveApplicationDataStatusDeprecated (state, action) {
            state.saveApplicationDataStatus = action.payload
        },
        setBusinessContactDeprecated(state, action) {
            Object.assign(state,action.payload)
        },
        setAddressForServiceDeprecated(state, action) {
            state.serviceCivicAddress = action.payload
        },
        setAddressForFinancialRecordsDeprecated(state, action) {
            state.financialRecordsLocation = action.payload
        },
        setLicenceHistoryDetailsDeprecated (state, action) {
            state.licenceHistoryList = action.payload
        },
        setCriminalHistoryDetailsDeprecated (state, action) {
            state.criminalHistoryData = action.payload
        },
        setWorkHistoryDetailsDeprecated (state, action) {
            state.workHistoryData = action.payload
        },
        setLicenceSuspensionDetailsDeprecated (state, action) {
            state.licenceSuspendedData = action.payload
        },
        setAdditionalBranchesDeprecated (state, action) {
            state.additionalBranches = action.payload
        },
        setSupportingDocumentsDeprecated (state, action) {
            Object.assign(state, action.payload)
        },
        // setSuretyBondDocuments (state, action) {
        //     Object.assign(state, action.payload)
        // },
        setTrustAccountDetails (state, action) {
            Object.assign(state, action.payload)
        },
        setSuretyBondConfirmationDeprecated(state, action) {
            // The surety bond CONFIRMation flag is not needed.
            // This parameter will be used for saving the bond receved date.
            //state.confirmSuretyBond = action.payload
        },
        setApplicationStatusDeprecated(state, action) {
            state.applicationStatus = action.payload
        },
        setLicenceStatusDeprecated(state, action) {
            state.licenceStatus = action.payload
        },
        setLicenceApplicationPaymentStatusDeprecated(state, action) {
            state.paymentStatus = action.payload
        },
        setSuretyBondReceivedStatusDeprecated(state, action) {
            state.suretyBondStatus = action.payload
        },
        setConfirmSuretyBondDeprecated(state, action) {
            state.confirmSuretyBond = action.payload
        },
        setBLTCollectionReviewDataDeprecated(state, action) {
            let bltReviewData = bltCollectionAgencyReviewData(action.payload)
            Object.assign(state, {reviewDataCollectionDebt : bltReviewData})
        },
        setInternalNotesDeprecated(state, action) {
            state.internalNotes = action.payload
        },
        updateBLTAgencyApplicationReviewItemDeprecated(state, action) { 
            const {key, item, reviewItemIndex} = action.payload

            if(key === "documentsDataMap") {
                state.reviewDataCollectionDebt[key] = item
                return
            }

            let reviewData = state.reviewDataCollectionDebt

            // const compareDocumentsData = (store,updated) => {
            //     if(store && Array.isArray(store)
            //         && Array.isArray(updated)
            //         && store.length === updated.length)
            //     {
            //         for(let i = 0; i < store.length; i++) {
            //             let _s = store[i]
            //             let _reviewItem = updated[i]
            //             for (const _k in _reviewItem) {

            //                 if(_k === "review")
            //                     continue

            //                 if (Object.hasOwnProperty.call(_reviewItem, _k)) {
            //                     if(Object.hasOwnProperty.call(_s, _k)) {
            //                         const e = _reviewItem[_k];
            //                         const element = _s[_k];

            //                         if(e !== element) {
            //                             return false
            //                         }
            //                     } else {
            //                         return false
            //                     }
            //                 }
            //             }
            //         }
            //         return true
            //     }
            //     else
            //     {
            //         return false
            //     }
            // }

            const compareReviewData = (storeItem, updatedItem, sItemIndex) => {
                // If two items are identical then the index breaks the tie
                if(!isNaN(reviewItemIndex) && reviewItemIndex !== sItemIndex) {
                    return false;
                }
                for (const _k in storeItem) {
                    if(_k === "review")
                        continue

                    if (Object.hasOwnProperty.call(storeItem, _k)) {
                        if(Object.hasOwnProperty.call(updatedItem, _k)) {
                            const e = storeItem[_k];
                            const element = updatedItem[_k];

                            if(e !== element) {
                                return false
                            }
                        } else {
                            return false
                        }
                    }
                }
                return true
            }

            if(reviewData[key] && Array.isArray(reviewData[key])) {
                let storeItems = [...reviewData[key]]
                let storeIndex = -1
                let storeItem = storeItems.find((_sItem, index) => {
                    if(_sItem.data !== null || _sItem.data !== undefined) {

                        if(key === "suretyBondDataMap" && index === reviewItemIndex) { 
                            storeIndex = index
                            return true
                        } else {
                            if(compareReviewData(_sItem, item, index)) {
                                storeIndex =index
                                return true
                            }
                        }
                    }

                    return false
                })

                if(storeItem && storeIndex >= 0) {
                    storeItems.splice(storeIndex,1,item)
                    state.reviewDataCollectionDebt[key] = storeItems
                }
            }
        },
        setFetchApplicationRequestStatusDeprecated(state, action) {
            state.fetchApplicationRequestStatus = action.payload
        },
        setAgencyApplicationLockedDeprecated(state, action) {
            state.locked = action.payload
        }
    }
})

export const {
    resetApplicationDataDeprecated,
    setApplicationDataDeprecated,
    setSaveApplicationDataStatusDeprecated,
    setAddressForServiceDeprecated,
    setBusinessContactDeprecated,
    setAddressForFinancialRecordsDeprecated,
    setLicenceHistoryDetailsDeprecated,
    setCriminalHistoryDetailsDeprecated,
    setWorkHistoryDetailsDeprecated,
    setLicenceSuspensionDetailsDeprecated,
    setAdditionalBranchesDeprecated,
    setSupportingDocumentsDeprecated,
    setTrustAccountDetailsDeprecated,
    setSuretyBondConfirmationDeprecated,
    setApplicationReferenceDataDeprecated,
    setApplicationStatusDeprecated,
    setLicenceStatusDeprecated,
    setLicenceApplicationPaymentStatusDeprecated,
    setSuretyBondReceivedStatusDeprecated,
    setConfirmSuretyBondDeprecated,
    setBLTCollectionReviewDataDeprecated,
    setInternalNotesDeprecated,
    updateBLTAgencyApplicationReviewItemDeprecated,
    setFetchApplicationRequestStatusDeprecated,
    navigationEventDeprecated,
    setAgencyApplicationLockedDeprecated,
} = collectionApplicationSlice.actions

export const processApplicationResponse = (businessLicenceList, dispatch) => {
    if(businessLicenceList
        && Array.isArray(businessLicenceList)
        && businessLicenceList.length > 0)
    {
        let mainApplication = null
        let agentApplications = []
        let branchApplications = []

        businessLicenceList.forEach(respApp => {
            if(respApp) {
                const app = {...respApp}

                if (app.documents?.length) {
                    // For some reason, a deleted document comes back in the response after marking as "DELETE" 
                    // If such document is present in the request the following time, it fails with an error.
                    // To save such scenario, such documents are removed from the respponse so that it does 
                    // go in the subsequent save request.
                    const filteredDocuments = app.documents.filter(doc => doc.changeType !== "DELETE")
                    app.documents = filteredDocuments
                }

                if(app.businessApplicationHistoryData?.length) {
                    delete app.businessApplicationHistoryData
                    app.businessApplicationHistoryData = []
                }
    
                if(isAgencyTypeApplication(app)) {
                    if(!app.businessApplicationId) { 
                        dispatch(setAgencyApplication(app))
                        mainApplication = app
                    }
                    else { 
                        branchApplications.push(app)
                    }
                } else if(isIndividualTypeApplication(app)) {
                    agentApplications.push(app)
                } else { 
                    console.error("*** unknown", app.licencingSubType);
                }
            }
        })
        // sending the entire dataset of additional applications
        // to be processed together. This will be huge improvement for 
        // multiple agent applications. 
        dispatch(setAdditionalApplications({
            branchApplications,
            agentApplications
        }))

        dispatch(setServerRequestStatus(REQUEST_STATUS.SUCCESS))

        let retApplication = mainApplication

        if(!retApplication) { 
            if(agentApplications?.length > 0) {
                retApplication = agentApplications[0]
            }
            else if(branchApplications?.length > 0) {
                retApplication = branchApplications[0]
            }
        }

        return retApplication
    }
}

export const fetchMyApplicationData = (returnAll) => async (dispatch, getState) => {
    const { userData } = getState().userAuth

    if(getState().primaryAgencyApplication.serverRequestStatus === REQUEST_STATUS.IN_PROGRESS) {
        return Promise.reject(ERROR_CODE.REQUEST_OUTSTANDING)
    }

    dispatch(setServerRequestStatus(REQUEST_STATUS.IN_PROGRESS))

    if(userData && userData.username) {
        return fetch(FETCH_APPLICATIONS_URL)
            .then(resp => resp.json())
            .then(data => {
                const {businessLicenceList} = data

                if(businessLicenceList
                    && Array.isArray(businessLicenceList)
                    && businessLicenceList.length > 0)
                {
                    const retApplication = processApplicationResponse(businessLicenceList, dispatch)

                    if(returnAll) {
                        
                        const additionalAppsObject = getState().additionalApplications;
                        let additionalApps = [];
                        if(additionalAppsObject?.agentApplications) {
                            additionalApps = [...additionalAppsObject.agentApplications];
                        }
                        if(additionalAppsObject?.additionalBranchApplications) {
                            additionalApps = [...additionalApps, ...additionalAppsObject.additionalBranchApplications];
                        }

                        return {
                            agencyApplication : getState().primaryAgencyApplication.application,
                            additionalApplications : additionalApps
                        }
                    }
                    return retApplication
                } else {
                    return Promise.reject(ERROR_CODE.EMPTY_RESPONSE)
                }
            })
            .catch(err => {
                dispatch(setServerRequestStatus(REQUEST_STATUS.ERROR))
                return Promise.reject(err)
            })
    } else {
        return Promise.reject(ERROR_CODE.UNKNOWN_USER)
    }
}

/*
 * This function will fetch the primary application and its associated applications
 * (like additional branches and agent applications) and combine data together and 
 * set the data in the redux store.
 * 
 * The function is ideal for admin UI where an agency is clicked and its details 
 * are shown in a details page.
 * 
 * The return value is the main application data (with branch data merged) or else 
 * rejected promise in case of any error.
 */
export const fetchApplicationWithIdAndSetStore = (applicationId, fetchFromArchive = false, noAddtionalAppReset) => async (dispatch, getState) => {
    if(getState().primaryAgencyApplication.serverRequestStatus === REQUEST_STATUS.IN_PROGRESS) {
        return Promise.reject(ERROR_CODE.REQUEST_OUTSTANDING)
    }

    // By default, reset the additional branch and agent applications
    if(!noAddtionalAppReset) {
        dispatch(resetAdditionalApplications())
    }
    
    dispatch(setServerRequestStatus(REQUEST_STATUS.IN_PROGRESS))
    let requestUrl = FETCH_APPLICATIONS_URL

    if(fetchFromArchive) 
        requestUrl = FETCH_ARCHIVE_APPLICATIONS_URL

    if(window.location.hostname === "localhost")
        requestUrl = requestUrl + "WithId"

    const resp = await fetch(requestUrl + "?id=" + applicationId)

    if(resp.status === 401 || resp.status === 403) {
        dispatch(setServerRequestStatus(REQUEST_STATUS.ERROR)) 
        return Promise.reject(ERROR_CODE.UNAUTHORISED_ACCESS)
    }

    const respJson = await resp.json()
    const businessLicenceList = []

    if(respJson.businessLicenceList 
        && Array.isArray(respJson.businessLicenceList)
        && respJson.businessLicenceList.length > 0)
    {
        Array.prototype.push.apply(businessLicenceList,respJson.businessLicenceList)
        const requestedApplication = respJson.businessLicenceList.find(d => d.id === applicationId)

        // find out additional applications for the agency application
        if(requestedApplication && isAgencyTypeApplication(requestedApplication)) 
        {
            if(window.location.hostname === "localhost")
                requestUrl = FETCH_APPLICATIONS_URL + "WithBusinessId"

            let paramName = "businessApplicationId"

            if(fetchFromArchive) {
                paramName = "businessApplicationArchiveId"
            }

            const agentApplicationsReq = await fetch(requestUrl + `?${paramName}=${applicationId}`)

            if(agentApplicationsReq.status === 401 || agentApplicationsReq.status === 403) { 
                dispatch(setServerRequestStatus(REQUEST_STATUS.ERROR))
                return Promise.reject(ERROR_CODE.UNAUTHORISED_ACCESS)
            }

            const agentApplicationsResp = await agentApplicationsReq.json()
             
            if(agentApplicationsResp.businessLicenceList 
                && Array.isArray(agentApplicationsResp.businessLicenceList)
                && agentApplicationsResp.businessLicenceList.length > 0) 
            {
                const collectionTypeAgentApplications = agentApplicationsResp.businessLicenceList.filter(app => isIndividualTypeApplication(app))
                
                if(collectionTypeAgentApplications.length > 0)
                    Array.prototype.push.apply(businessLicenceList,collectionTypeAgentApplications)

                // mortgage brokerage will always have a principal broker application. 
                // find the id of principal broker application and fetch the application with businessLicenceData
                // to populate the details for principal broker.
                if(requestedApplication.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION 
                    || requestedApplication.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION) { 
                    
                    // fetch the principal broker application
                    const principalBrokerApplications = agentApplicationsResp.businessLicenceList.filter(app => (
                        app.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION 
                        || app.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION))
                    if(principalBrokerApplications && principalBrokerApplications.length > 0) { 
                        const principalBrokerId = principalBrokerApplications[0].id
                        const principalBrokerBusinessLicenceData =  principalBrokerApplications[0].businessLicenceData
                        
                        if(!IsInternalId(principalBrokerId) && !principalBrokerBusinessLicenceData) { 
                            const principalBrokerApplicationReq = await fetch(requestUrl + "?id=" + principalBrokerId) 
    
                            if(principalBrokerApplicationReq.status === 401 || principalBrokerApplicationReq.status === 403) { 
                                dispatch(setServerRequestStatus(REQUEST_STATUS.ERROR))
                                return Promise.reject(ERROR_CODE.UNAUTHORISED_ACCESS)
                            }
                
                            const principalBrokerApplicationResp = await principalBrokerApplicationReq.json()
                
                            if(principalBrokerApplicationResp.businessLicenceList 
                                && Array.isArray(principalBrokerApplicationResp.businessLicenceList)
                                && principalBrokerApplicationResp.businessLicenceList.length > 0) 
                            {
                                const principalBrokerApplications = principalBrokerApplicationResp.businessLicenceList
                                
                                if(principalBrokerApplications.length > 0)
                                    Array.prototype.push.apply(businessLicenceList,principalBrokerApplications)
                            }
                        }
                    }
                }
            }

            if(requestedApplication.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
                || requestedApplication.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION
                || requestedApplication.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
                || requestedApplication.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL) { 
                    let url;
                    if(window.location.hostname === "localhost") {
                        url = '/api/branches'
                    }
                    else {
                        url = requestUrl
                    }
                    const branchApplicationsReq = await fetch(`${url}?branchId=${applicationId}`)

                    if(branchApplicationsReq.status === 401 || branchApplicationsReq.status === 403) { 
                        dispatch(setServerRequestStatus(REQUEST_STATUS.ERROR))
                        return Promise.reject(ERROR_CODE.UNAUTHORISED_ACCESS)
                    }
        
                    const branchApplicationsResp = await branchApplicationsReq.json()
        
                    if(branchApplicationsResp.businessLicenceList 
                        && Array.isArray(branchApplicationsResp.businessLicenceList)
                        && branchApplicationsResp.businessLicenceList.length > 0) 
                    {
                        const branchApplications = branchApplicationsResp.businessLicenceList
                        
                        if(branchApplications.length > 0)
                            Array.prototype.push.apply(businessLicenceList,branchApplications)
                    }
            }
        }
    }

    dispatch(setServerRequestStatus(REQUEST_STATUS.SUCCESS))

    if(businessLicenceList.length) { 
        return processApplicationResponse(businessLicenceList, dispatch)
    }
    else { 
        return Promise.reject(ERROR_CODE.EMPTY_RESPONSE)
    }
}

function agencyPaymentItem(applicationType, applicationMode, feeList) {
    if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => fee.name === "COLLECTION_AGENCY_RENEWAL_LICENCE_FEE")
        } else {
            return feeList.find(fee => fee.name === "COLLECTION_AGENCY_APPLICATION_LICENCE_FEE")
        }
    } else if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => fee.name === "DEBT_MANAGEMENT_RENEWAL_LICENCE_FEE")
        } else {
            return feeList.find(fee => fee.name === "DEBT_MANAGEMENT_APPLICATION_LICENCE_FEE")
        }
    } else if(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) { 
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => fee.name === "MORTGAGE_BROKERAGE_RENEWAL")
        } else {
            return feeList.find(fee => fee.name === "MORTGAGE_BROKERAGE_NEW_APPLICATION")
        } 
    } else if(applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => fee.name === "MORTGAGE_LENDER_RENEWAL")
        } else {
            return feeList.find(fee => fee.name === "MORTGAGE_LENDER_NEW_APPLICATION")
        }
    } else if(applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => fee.name === "MORTGAGE_ADMINISTRATOR_RENEWAL")
        } else {
            return feeList.find(fee => fee.name === "MORTGAGE_ADMINISTRATOR_NEW_APPLICATION")
        }
    } else if(applicationType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE) {
        return feeList.find(fee => fee.name === "INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION")
    } else if(applicationType === APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_LICENCE) {
        return feeList.find(fee => fee.name === "INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION")
    } else if(applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE) {
        return feeList.find(fee => fee.name === "INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION")
    } else if(applicationType === APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_LICENCE) {
        return feeList.find(fee => fee.name === "INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION")
    }

    return null
}

function agencyAdditionalBranchItem(applicationType,applicationMode,feeList) {
    if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => fee.name === "COLLECTION_AGENCY_RENEWAL_ADDITIONAL_BRANCHES_FEE")
        } else {
            return feeList.find(fee => fee.name === "COLLECTION_AGENCY_ADDITIONAL_BRANCHES_FEE")
        }
    } else if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => fee.name === "DEBT_MANAGEMENT_RENEWAL_ADDITIONAL_LICENCE_FEE")
        } else {
            return feeList.find(fee => fee.name === "DEBT_MANAGEMENT_ADDITIONAL_BRANCHES_FEE")
        }
    }

    return null
}

function agentPaymentItem(applicationType, applicationMode, feeList) {
    if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => fee.name === "COLLECTOR_LICENCE_RENEWAL_FEE")
        } else {
            return feeList.find(fee => fee.name === "COLLECTOR_LICENCE_APPLICATION_FEE")
        }
    } else if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => (fee.name === "DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL_FEE" || fee.name === "DEBT_MANAGEMENT__INDIVIDUAL_RENEWAL_FEE"))
        } else {
            return feeList.find(fee => fee.name === "DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION_FEE")
        }
    } else if(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => (fee.name === "MORTGAGE_BROKERAGE_RENEWAL"))
        } else {
            return feeList.find(fee => (fee.name === "MORTGAGE_BROKERAGE_NEW_APPLICATION"))
        } 
    } else if(applicationType === APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE) { 
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => (fee.name === "PRINCIPAL_BROKER_RENEWAL"))
        } else {
            return feeList.find(fee => (fee.name === "PRINCIPAL_BROKER_NEW_APPLICATION"))
        } 
    } else if(applicationType === APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE) { 
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => (fee.name === "MORTGAGE_BROKER_RENEWAL"))
        } else {
            return feeList.find(fee => (fee.name === "MORTGAGE_BROKER_NEW_APPLICATION"))
        } 
    } else if(applicationType === APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE) { 
        if(applicationMode === APPLICATION_MODE_RENEW) {
            return feeList.find(fee => (fee.name === "ASSOCIATE_MORTGAGE_BROKER_RENEWAL"))
        } else {
            return feeList.find(fee => (fee.name === "ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION"))
        } 
    }
    else if(applicationType === "ASSOCIATE_MORTGAGE_BROKER_RETENTION_APPLICATION") {
        //For Licncec Transfer one agency to another case
        return feeList.find(fee => (fee.name === "ASSOCIATE_MORTGAGE_BROKER_RETENTION_APPLICATION"))
    }
    else if(applicationType === "MORTGAGE_BROKER_RETENTION_APPLICATION") {
        //For Licncec Transfer one agency to another case
        return feeList.find(fee => (fee.name === "MORTGAGE_BROKER_RETENTION_APPLICATION"))
    }

    return null
}

function calculatePaymentItems(
                        applicationType, 
                        applicationMode, 
                        primaryApplication, 
                        additionalBranchApplications, 
                        agentApplications,
                        feeList, 
                        paymentRequestedForIds) {
    const paymentItems = []

    const isPaymentRequestedForId = (id) => {
        if(!paymentRequestedForIds || paymentRequestedForIds.length === 0) {
            return true
        }

        return (paymentRequestedForIds.findIndex(requestedId => requestedId === id) !== -1)
    }
    
    const agencyFeeItem = agencyPaymentItem(applicationType,applicationMode,feeList)
    if(!agencyFeeItem) {
        console.error("payment item not found for agency")
        return paymentItems;
    }

    if(isPaymentRequestedForId(primaryApplication.id) && isReadyForPayment(primaryApplication)) {
        paymentItems.push({
            itemCode : agencyFeeItem.itemCode,
            itemDescription : agencyFeeItem.itemDescription,
            quantity : 1,
            fees : agencyFeeItem.value,
            applicationId : primaryApplication.id
        })
    }

    if(additionalBranchApplications && 
        Array.isArray(additionalBranchApplications)) { 
        additionalBranchApplications.forEach(branchApplication => {
            // Currently checking if the primary application for payment to add branch application
            // In future, when there is a different flow for the branch application, check the readiness of 
            // the branch application itself.
            if(!branchApplication.markedDeleted 
                && branchApplication.businessLicenceData?.userApplicationReviewComplete
                && isPaymentRequestedForId(branchApplication.id)
                && branchApplication.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT
                && branchApplication.businessLicenceData.additionalBranches
                && Array.isArray(branchApplication.businessLicenceData.additionalBranches)) {
                    const validBranches = branchApplication.businessLicenceData.additionalBranches.filter(b => validateBranchData(b))
                    const totalAdditionalBranches = validBranches.length

                    if(totalAdditionalBranches > 0) {
                        const additionalBranchFeeItem = agencyAdditionalBranchItem(applicationType,applicationMode,feeList)
        
                        if(additionalBranchFeeItem) {
                            // need to add agency payment item with 0 cost
                            // This is required because item codes for agency
                            // and branch are same.
                            if(paymentItems.length === 0) {
                                paymentItems.push({
                                    itemCode : agencyFeeItem.itemCode,
                                    itemDescription : agencyFeeItem.itemDescription,
                                    quantity : 1,
                                    fees : 0,
                                    applicationId : primaryApplication.id
                                })
                            }

                            for(let i = 0; i < totalAdditionalBranches; i++) {
                                paymentItems.push({
                                    itemCode : additionalBranchFeeItem.itemCode,
                                    itemDescription : additionalBranchFeeItem.itemDescription,
                                    quantity : 1,
                                    fees : additionalBranchFeeItem.value,
                                    applicationId : branchApplication.id
                                })
                            }
                        } else {
                            console.error("payment item not found for additinal branch")
                        }
                    }
            }
        })
    }
    
    if(agentApplications && 
        Array.isArray(agentApplications)) {
        const validAgentEntries = agentApplications.filter(agentApplication => (validateAgentData(agentApplication) 
                                                                                    && isPaymentRequestedForId(agentApplication.id)
                                                                                    && isReadyForPayment(agentApplication)))
        const totalAgents = validAgentEntries.length
        if(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
            /* parse principal broker items */
            const principalBrokerItems = validAgentEntries.filter(app => ((app.licencingSubType === 
                                                                        LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION) || (app.licencingSubType === 
                                                                            LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION)))
            if(principalBrokerItems && principalBrokerItems.length > 0) { 
                const principalBrokerPaymentItem = agentPaymentItem(
                                                        APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE, 
                                                        applicationMode, 
                                                        feeList)
                if(principalBrokerPaymentItem) {
                    for(let i = 0; i < principalBrokerItems.length ; i++) { 
                        const agentApp = principalBrokerItems[i]
                        paymentItems.push({
                            itemCode : principalBrokerPaymentItem.itemCode,
                            itemDescription : principalBrokerPaymentItem.itemDescription,
                            quantity : 1,
                            fees : principalBrokerPaymentItem.value,
                            applicationId : agentApp.id
                        })
                    }
                }
            }

            
            /* Prepare Payment items for brokers */

            validAgentEntries.forEach((app) => {
                if ((app.licencingSubType ===
                    LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION) ||
                    (app.licencingSubType ===
                        LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION)

                ) {
                    let brokerPaymentItem;

                    //if licncec transfer from one agency to another 
                    if (app.businessLicenceData.currentlyBrokerInNS && app.licencingSubType ===
                        LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION) {
                        brokerPaymentItem = agentPaymentItem(
                            "MORTGAGE_BROKER_RETENTION_APPLICATION",
                            applicationMode,
                            feeList)
                    }
                    else {
                        brokerPaymentItem = agentPaymentItem(
                            APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
                            applicationMode,
                            feeList)

                    }

                    if (brokerPaymentItem) {
                        paymentItems.push({
                            itemCode: brokerPaymentItem.itemCode,
                            itemDescription: brokerPaymentItem.itemDescription,
                            quantity: 1,
                            fees: brokerPaymentItem.value,
                            applicationId: app.id
                        })
                    }
                }
                else if (((app.licencingSubType ===
                    LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION) || (app.licencingSubType ===
                        LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION))

                ) {
                    let associateBrokerPaymentItem
                    //if licncec transfer from one agency to another 
                    if (app.businessLicenceData.currentlyBrokerInNS && app.licencingSubType ===
                        LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION) {
                        associateBrokerPaymentItem = agentPaymentItem(
                            "ASSOCIATE_MORTGAGE_BROKER_RETENTION_APPLICATION",
                            applicationMode,
                            feeList)
                    }
                    else {
                        associateBrokerPaymentItem = agentPaymentItem(
                            APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE,
                            applicationMode,
                            feeList)
                    }

                    if (associateBrokerPaymentItem) {
                        paymentItems.push({
                            itemCode: associateBrokerPaymentItem.itemCode,
                            itemDescription: associateBrokerPaymentItem.itemDescription,
                            quantity: 1,
                            fees: associateBrokerPaymentItem.value,
                            applicationId: app.id
                        })
                    }
                }
            })

            /* parse broker items */

            // const brokerItems = validAgentEntries.filter(app => (((app.licencingSubType ===
            //     LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION) ||
            //     (app.licencingSubType ===
            //         LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION))
            //         && app
            // ))
            // 
            // if(brokerItems && brokerItems.length > 0) { 
            //     const brokerPaymentItem = agentPaymentItem(
            //                                 APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE, 
            //                                 applicationMode, 
            //                                 feeList)
            //     if(brokerPaymentItem) {
            //         for(let i = 0; i < brokerItems.length ; i++) { 
            //             const agentApp = brokerItems[i]
            //             paymentItems.push({
            //                 itemCode : brokerPaymentItem.itemCode,
            //                 itemDescription : brokerPaymentItem.itemDescription,
            //                 quantity : 1,
            //                 fees : brokerPaymentItem.value,
            //                 applicationId : agentApp.id
            //             })
            //         }
            //     }
            // }

            /* parse associate broker items for payment */

            // const associateBrokerItems = validAgentEntries.filter(app => ((app.licencingSubType === 
            //                                                         LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION) || (app.licencingSubType === 
            //                                                             LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION)))
            // if(associateBrokerItems && associateBrokerItems.length > 0) { 
            //     const associateBrokerPaymentItem = agentPaymentItem(
            //                                         APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE, 
            //                                         applicationMode, 
            //                                         feeList)
            //     if(associateBrokerPaymentItem) {
            //         for(let i = 0; i < associateBrokerItems.length ; i++) { 
            //             const agentApp = associateBrokerItems[i]
            //             paymentItems.push({
            //                 itemCode : associateBrokerPaymentItem.itemCode,
            //                 itemDescription : associateBrokerPaymentItem.itemDescription,
            //                 quantity : 1,
            //                 fees : associateBrokerPaymentItem.value,
            //                 applicationId : agentApp.id
            //             })
            //         }
            //     }
            // }
        } else { 
            if(totalAgents > 0) {
                const agentItem = agentPaymentItem(applicationType, applicationMode, feeList)
    
                if(agentItem) {
                    for(let i = 0; i < totalAgents ; i++) {
                        
                        const agentApp = validAgentEntries[i]
    
                        paymentItems.push({
                            itemCode : agentItem.itemCode,
                            itemDescription : agentItem.itemDescription,
                            quantity : 1,
                            fees : agentItem.value,
                            applicationId : agentApp.id
                        })
                    }
                } else {
                    console.error("payment item not found for agent")
                }
            }
        }
    }

    return paymentItems
}

function postPaymentData(paymentResponse) {

    const {
        url,
        businessID,
        businessTransactionID,
        hash,
        totalFee,
        lineItems,
        lang,
        version,
        email,
        comment,
        timestamp,
        returnURL,
        cancelURL
    } = paymentResponse

    var postForm = document.createElement("form");
    var businessIdInput = document.createElement("input");
    var totalFeeInput = document.createElement("input");
    var lineItemsInput = document.createElement("input");
    var hashInput = document.createElement("input");
    var langInput = document.createElement("input");
    var versionInput = document.createElement("input");
    var emailInput = document.createElement("input");
    var commentInput = document.createElement("input");
    var timeStampInput = document.createElement("input");
    var businessTransactionIDInput = document.createElement("input");
    var returnURLInput = document.createElement("input");
    var cancelURLInput = document.createElement("input");

    postForm.setAttribute("method", "post");
    postForm.setAttribute("action", url);

    // console.log("businessID:" + businessID);
    businessIdInput.setAttribute("name", "businessID");
    businessIdInput.setAttribute("value", businessID);
    postForm.appendChild(businessIdInput);

    // console.log("hash :" + hash);
    hashInput.setAttribute("name", "hash");
    hashInput.setAttribute("value", hash);
    postForm.appendChild(hashInput);

    // console.log("totalFee:" + totalFee);
    totalFeeInput.setAttribute("name", "totalFee");
    totalFeeInput.setAttribute("value", totalFee);
    postForm.appendChild(totalFeeInput);

    // console.log("businessTransactionID:" + businessTransactionID);
    businessTransactionIDInput.setAttribute("name", "businessTransactionID");
    businessTransactionIDInput.setAttribute("value", businessTransactionID);
    postForm.appendChild(businessTransactionIDInput);

    // console.log("lineItems:" + lineItems);
    lineItemsInput.setAttribute("name", "lineItems");
    lineItemsInput.setAttribute("value", lineItems);
    postForm.appendChild(lineItemsInput);

    // console.log("lang:" + lang);
    langInput.setAttribute("name", "lang");
    langInput.setAttribute("value", lang);
    postForm.appendChild(langInput);

    // console.log("apiVersion:" + version);
    versionInput.setAttribute("name", "apiVersion");
    versionInput.setAttribute("value", version);
    postForm.appendChild(versionInput);

    // console.log("email:" + email);
    emailInput.setAttribute("name", "email");
    emailInput.setAttribute("value", email);
    postForm.appendChild(emailInput);

    // console.log("comment:" + comment);
    commentInput.setAttribute("name", "comment");
    commentInput.setAttribute("value", comment);
    postForm.appendChild(commentInput);

  	// console.log("timestamp:" + timestamp);
  	timeStampInput.setAttribute("name", "timestamp");
  	timeStampInput.setAttribute("value", timestamp);
  	postForm.appendChild(timeStampInput);

    // console.log("returnURL:" + returnURL);
    returnURLInput.setAttribute("name", "returnURL");
    returnURLInput.setAttribute("value", returnURL);
    postForm.appendChild(returnURLInput);

    // console.log("cancelURL:" + cancelURL);
    cancelURLInput.setAttribute("name", "cancelURL");
    cancelURLInput.setAttribute("value", cancelURL);
    postForm.appendChild(cancelURLInput);

    document.body.appendChild(postForm);

    // console.log('Posting application ' + postForm + ' to GPS at ' + url);
    postForm.submit();
    // console.log('Completed Posting application ' + postForm + ' to GPS at ' + url);

    document.body.removeChild(postForm);
}

export const initiatePayment_v1 = (applicationType, applicationMode, paymentRequestedForIds) => async(dispatch, getState) => {
    const {userData, csrfToken} = getState().userAuth
    const {primaryAgencyApplication, additionalApplications} = getState()
    const {feeDataList, feeMortgageDataList} = primaryAgencyApplication.referenceData
    const finalList = [...feeDataList,...feeMortgageDataList]

    if(userData && feeDataList) {
        const userID = userData.username
        const applicantName = fullName(userData)
        const email = userData.email
        const paymentItems = calculatePaymentItems(
                                        applicationType,
                                        applicationMode,
                                        primaryAgencyApplication.application,
                                        additionalApplications.additionalBranchApplications.filter(app => !app.markedDeleted),
                                        additionalApplications.agentApplications,
                                        finalList,
                                        paymentRequestedForIds
                                    )

        let headers = new Headers()
        headers.append('Content-Type',"application/json")
        headers.append("X-CSRF-TOKEN", csrfToken)

        dispatch(setLicenceApplicationPaymentStatus(PAYMENT_STATUS_INPROGRESS))
        dispatch(savePaymentRequestDetails(paymentItems.map(({applicationId}) => ({applicationId}))))

        const payBody = {
                userID,
                applicantName,
                email,
                paymentItems,
        }

        //console.log("pay post data : " + JSON.stringify(payBody));

        return fetch(PAYMENT_URL,{
            method : "POST",
            headers: headers,
            body : JSON.stringify(payBody)
        })
        .then(resp => resp.json())
        .then(data => {
            //console.log(data)

            if(1) {
                postPaymentData(data)
                return
            }

            // dispatch(setLicenceApplicationPaymentStatus(PAYMENT_STATUS_SUCCESS))

            // if(applicationMode === APPLICATION_MODE_RENEW) {
            //     dispatch(setApplicationStatus(APPLICATION_RENEWAL_STATUS_SUBMITTED))
            //     dispatch(setSuretyBondReceivedStatus(SURETYBOND_STATUS_RECEIVED))
            //     dispatch(setCollectorapplicationStatus(APPLICATION_RENEWAL_STATUS_SUBMITTED))
            // }
            // else {
            //     dispatch(setCollectorapplicationStatus(APPLICATION_STATUS_SUBMITTED))
            //     dispatch(setApplicationStatus(APPLICATION_STATUS_SUBMITTED))
            //     dispatch(setSuretyBondReceivedStatus(SURETYBOND_STATUS_NOTRECEIVED))
            // }
        })
        .catch(err => {
            console.error(err)
            dispatch(setLicenceApplicationPaymentStatus(PAYMENT_STATUS_FAILURE))
        })
    }
}

export default collectionApplicationSlice.reducer
